export default __webpack_public_path__ + "static/media/Bonus_History_Smart_Lifestyle.e88dbbd8.pdf";